/* eslint-disable jsx-a11y/img-redundant-alt */
import React from 'react';
import Spinner from '../spinner';
import {ProductImageItemProps } from '../interfaces'
import './ProductImageItem.scss';

const ProductImageItem: React.FC<ProductImageItemProps> = ({
  media,
  isLoaded,
  isZoomed,
  pointer,
  onLoad,
  onError,
  onPointerMove,
  onClick,
}) => (
  <div
    className={`image-wrapper ${isZoomed ? 'is-zoomed' : ''}`}
    onMouseMove={(event) => onPointerMove(event, media.id)}
    onClick={() => onClick(media.id)}
  >
    {!isLoaded && (
      <div className="spinner-overlay">
        <Spinner />
      </div>
    )}

    <img
      src={media.url}
      alt={`${media.materialName} product`}
      onLoad={() => onLoad(media.id)}
      onError={(event) => onError(event, media.id)}
      className={isZoomed ? 'zoomed-image' : ''}
      style={{
        display: 'block',
        opacity: isLoaded ? 1 : 0,
        outline: 'none',
        boxShadow: 'none',
        transformOrigin: `${pointer.x}% ${pointer.y}%`,
      }}
    />
  </div>
);

export default ProductImageItem;
